import PortalledContent from "./PortalledContent";

export default PortalledContent;
